import React from 'react';
import { BaseDialog, BaseButton } from '../base';
import * as S from './ai-assistant.styles';

export interface IExtensionUnavailableModalProps {
    open: boolean;
    onClose: () => void;
    onGoToStore: () => void;
    onRetry: () => void;
}

export const ExtensionUnavailableModal: React.FC<IExtensionUnavailableModalProps> = ({
    open,
    onClose,
    onGoToStore,
    onRetry,
}) => {
    if (!open) {
        return null;
    }

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            renderTitle="Enable Ctrl Enter extension"
            showCloseButton={true}
            maxWidth="sm"
            fullWidth={true}>
            <S.ExtensionHelpContent>
                <S.ExtensionHelpText>
                    To use Talk to AI, please install the Ctrl Enter extension and make sure it is enabled.
                </S.ExtensionHelpText>
                <S.ExtensionHelpList>
                    <li>Click Go to Chrome Store and install the extension.</li>
                    <li>Turn extension ON in Chrome: 3 dots menu - Extensions - Manage Extensions.</li>
                    <li>
                        Complete extension authorization when the install tab opens. If it was closed, open Extensions
                        tab in Chrome, click Enter Control extension, and follow its instructions.
                    </li>
                </S.ExtensionHelpList>
                <S.ExtensionActionRow>
                    <BaseButton
                        variant="outlined"
                        type="button"
                        onClick={() => {
                            onClose();
                            onRetry();
                        }}>
                        I enabled it, reload page
                    </BaseButton>
                    <BaseButton variant="primary" type="button" onClick={onGoToStore}>
                        Go to Chrome Store
                    </BaseButton>
                </S.ExtensionActionRow>
            </S.ExtensionHelpContent>
        </BaseDialog>
    );
};
